.spinner {
  border: 6px solid #efefef;
  border-top: 6px solid var(--rs-theme);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
  // margin-top: 25%;
}

.inverted {
  border: 6px solid var(--rs-theme-darkest);
  border-top: 6px solid #efefef;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader {
  margin-top: 25vh;
}

.newLoader {
  margin: 0 auto;
  display: block;
  max-width: 90%;
  max-height: 100vh;
}
